import { interpolateLab } from 'd3-interpolate';
import { color as d3Color } from 'd3-color';

const colors = {
    violet: '#7376aa',
    red: '#e55d7b',
    green: '#a1e457',
    yellow: '#ffa51f',
    chromaticDarkViolet: '#525683',
};

export function lighten(color, amount = 0.1) {
    interpolateLab(color, 'white')(amount);
}

export function darken(color, amount = 0.1) {
    interpolateLab(color, 'black')(amount);
}

export function alpha(color, opacity = 1.0) {
    return Object.assign(d3Color(color), { opacity }) + "";
}

export default colors;



// WEBPACK FOOTER //
// ./src/style/colors.js